import { FiltersBar, OptionList, SearchSelect, SelectTrigger } from '@ingrid/luterkort-react';
import { ShippingLogo } from '@ingrid/react-shipping-logo';

import { useTranslation } from '~src/i18n/use-translation';
import { useShippingMethodListQuery } from '~src/main/queries';

export interface CarrierFilterProps {
  value: string[];
  onChange: (carriers: string[]) => void;
}

export function CarrierFilter({ onChange, value }: CarrierFilterProps) {
  const { data = [] } = useShippingMethodListQuery();
  const { t } = useTranslation();

  return (
    <SearchSelect.Root onValueChange={onChange} shouldCloseOnSelect={false} value={value} multiple>
      <SearchSelect.Trigger asChild>
        <FiltersBar.Button>
          {t('common.carrierProduct')}
          <SelectTrigger.Icon />
        </FiltersBar.Button>
      </SearchSelect.Trigger>

      <SearchSelect.Content style={{ maxHeight: '482px!important' }}>
        <OptionList.Viewport>
          {data.map(method => (
            <OptionList.Item key={`${method.id}-${method.name}`} spacing="sm" value={method.id ?? ''}>
              <ShippingLogo method={method.id ?? 'fallback'} width={30} />
              <OptionList.ItemText>{method.name}</OptionList.ItemText>
              <OptionList.ItemIndicator>
                <OptionList.CheckmarkIcon />
              </OptionList.ItemIndicator>
            </OptionList.Item>
          ))}
        </OptionList.Viewport>
      </SearchSelect.Content>
    </SearchSelect.Root>
  );
}
